import React, { Component } from "react";
import "./NavButtons.scss";
import PropTypes from "prop-types";
import { ChevronLeft, ChevronRight, User } from "react-feather";
const { useRef } = React;


export class NavButtons extends Component {
  constructor(props) {
    super(props);
    // this.previous = React.createRef();
    // this.next = React.createRef();
  }

  handleClick = (direction) => {
    this.props.getDirection(direction);
  };
  render() {
    return (
      <div>
        <button
        style={{width:"30px",height:"30px",marginRight:"10px",border:"none",padding:"3px"}}
          onClick={() => this.handleClick("previous")}
          className={`navBtn ${
            this.props.disablePrevious ? this.props.disablePrevious() : ""
          }`}
        >
         <span> <ChevronLeft/></span> 
        </button>
        <button
        style={{width:"30px",height:"30px",border:"none",padding:"3px"}}
          onClick={() => this.handleClick("next")}
          className={`navBtn ${
            this.props.disableNext ? this.props.disableNext() : ""
          }`}
        >
          <span> <ChevronRight/></span> 
        </button>
      </div>
    );
  }
}
